/* 🤖 this file was generated by svg-to-ts */
export const matIconTurnedIn: {
  name: 'turned-in';
  data: string;
} = {
  name: 'turned-in',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2z"/></svg>`
};
